module.exports = __webpack_public_path__ + "fa-solid-900.woff2?0ab54153eeeca0ce03978cc463b257f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff2
// module id = 45
// module chunks = 0